import React, { Component } from 'react';
import { connect } from 'react-redux';
import {setPrice,setAmount,setOrderType} from '../../../../actions/ui/marketplace';
import {matchOrders} from '../../../../actions/orderbook/matchingEngine';
import ReactTooltip from 'react-tooltip'
import {lowestDenom, ROVER_SECONDS_PER_BLOCK, fancyTimeFormat} from '../../../../config';
import $ from 'jquery';
import {Decimal} from 'decimal.js';
Decimal.set({ precision: 18})
Decimal.set({ toExpNeg: -18 })

class OrderItem extends Component {
  constructor(){
    super()
    this.state = {show:false}
  }
  showTooltip(ref){
    this.setState({show:true})
    ReactTooltip.show(ref);
  }
  hideTooltip(ref){
    ReactTooltip.hide(ref);
    this.setState({show:false})
  }
  render() {
    let {amount,price,type,id,cml,amountCml,isBlank,orders} = this.props
    let color = this.props.type === 'buy' ? "#60ca60" : '#de7272';
    if(!isBlank){
      let opacity = orders.reduce((all,{mempool})=>{return mempool || all},false) ? 0.7 : 1;
      return (
        <>
          <tr
            style={{cursor:'pointer',opacity}}
            onClick={this.handleFormSubmit.bind(this,{id,price,type,amount:amountCml,orders})}
            ref={(c) => { this.ref = c; }}
            data-tip={`hello`} data-for={id}
            onMouseOver={this.showTooltip.bind(this,this.ref)}
            onMouseLeave={this.hideTooltip.bind(this,this.ref)}
          >
            <td style={{color}}>{price.toString().substring(0,8)}</td>
            <td>{amount.toString().substring(0,8)}</td>
            <td>{`${new Decimal(price).mul(new Decimal(amount)).toNumber()}`.substring(0,8)}</td>
            <td>{cml.toString().substring(0,8)}</td>
          </tr>

          {this.state.show &&
            <ReactTooltip id={id} place="right" type="dark" effect="solid" className='extraClass' delayHide={100}>
              {this.renderTable(orders)}
            </ReactTooltip>
          }
        </>
      );
    }
    else {
      return (
        <tr>
          <td style={{color}}>-</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
        </tr>
      )
    }
  }
  componentDidMount(){
    // setInterval(()=>{
    //   var items = orders.map(({nrgUnit,fixedUnitFee,amount,id,collateralizedNrg,depositNum,depositLeft,settleLeft,originalNrg,receives},i) => {
    //     let ratio = new Decimal(nrgUnit).div(new Decimal(originalNrg)).mul(new Decimal(receives)).toString()
    //     return (
    //       <tr key={Math.random()}>
    //         <td>{amount} {amountText}</td>
    //         <td>{fixedUnitFee !== '0' ? fixedUnitFee : collateralizedNrg} NRG</td>
    //         <td>≈ {fancyTimeFormat(parseInt(depositNum)*ROVER_SECONDS_PER_BLOCK['bc'])}</td>
    //         <td>{ratio} {amountText}</td>
    //       </tr>
    //     );
    //   });
    // },1000);
  }
  renderTable(orders){

    let amountText = this.props.type === 'buy' ? orders[0].receivesToChain.toUpperCase() : orders[0].sendsFromChain.toUpperCase();
    let priceText = this.props.type === 'buy' ? orders[0].sendsFromChain.toUpperCase() : orders[0].receivesToChain.toUpperCase();
    // <td>≈ {fancyTimeFormat(parseInt(depositNum)*ROVER_SECONDS_PER_BLOCK['bc'])}</td>

    var items = orders.map(({nrgUnit,fixedUnitFee,amount,id,collateralizedNrg,depositNum,depositLeft,settleLeft,originalNrg,receives},i) => {
      let ratio = new Decimal(nrgUnit).div(new Decimal(originalNrg)).mul(new Decimal(receives)).toString()
      return (
        <tr key={Math.random()}>
          <td>{amount} {amountText}</td>
          <td>{fixedUnitFee !== '0' ? fixedUnitFee : collateralizedNrg} NRG</td>
          <td>{depositLeft}</td>
          <td>{ratio} {amountText}</td>
        </tr>
      );
    });

    return (
      <div className="noHover">
        <table className="white-text transferDetails2">
          <thead>
            <tr>
              {['Amount','Collateral','Trade Lifespan', 'Increment'].map(o=>(<th key={o}>{o}</th>))}
            </tr>
          </thead>
          <tbody>
            {items}
          </tbody>
        </table>
      </div>
		)
  }

  handleFormSubmit({id,type,price,amount,orders}) {

    if($('#amount')) $('#amount')[0].value = amount.toString();
    if($('#price')) $('#price')[0].value = price.toString();

    this.props.setPrice(price.toString(),()=>{});
    this.props.setAmount(amount.toString(),()=>{});

    if(type !== 'buy') {
      $('#acquire')[0].click();
      this.props.setOrderType("BUY");
    }
    else {
      $('#leaseout')[0].click();
      this.props.setOrderType("SELL");
    }
    $('#amount').focus()
  }
}

export default connect(()=>({

}), {setPrice,setAmount,setOrderType,matchOrders})(OrderItem);
